module.exports = "/build/web/svg/sponsor/x-ict.95b1b598267baa4689c83cdb06a63253.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/x-ict.svg
// module id = 228
// module chunks = 24